import { create } from 'zustand'

import { Dto } from '@/types'

export type ServicesState = {
  services?: Dto['ServicesAvailabilityDto']
  actions: {
    setServices: (services: Dto['ServicesAvailabilityDto']) => void
  }
}

export const useServicesStore = create<ServicesState>()((set) => ({
  services: undefined,
  actions: {
    setServices: (services) => set({ services }),
  },
}))
